module.exports = __webpack_public_path__ + "img/DSC00023.554c1d23.JPG";